import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form, Icon } from '@anytag/shared-atoms';
import { PasswordField } from '@anytag/shared-molecules';
import { ResetPasswordFormValues, ResetPasswordFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext<ResetPasswordFormValues>();

  const values = watch();

  return (
    <Form.Body className="px-10 py-12 shadow-none">
      <h1 css={{ position: 'relative', fontSize: '20px', lineHeight: '100%', textAlign: 'center' }}>
        <Anchor to="/" css={{ position: 'absolute', top: '4px', left: '4px' }}>
          <Icon size={16} icon="arrow-left" variant="blue" />
        </Anchor>

        {t('Change your password')}
      </h1>
      <p css={{ fontSize: '14px', lineHeight: '140%', padding: '16px 0', textAlign: 'center' }}>
        {t('Please set a new password')}
      </p>

      <PasswordField<ResetPasswordFormKeys> name="password" title={t('Password.New Password')} dynamicError required />
      <PasswordField<ResetPasswordFormKeys> name="passwordConfirm" title={t('Confirm new password')} required />

      <ButtonSubmit
        variant="solid"
        loading={isSubmitting}
        title={t('Button.Update')}
        css={{ width: '100%', marginTop: '16px' }}
        disabled={!values.password || !values.passwordConfirm}
      />
    </Form.Body>
  );
};
